export const DOCUMENT_TYPE_FEATURE_KEY = 'documentType';